import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine, Cell } from 'recharts';
import type { SensitivityItem } from '../utils/financialCalculations';

function SensTooltip({ active, payload }: any) {
  if (!active || !payload?.length) return null;
  const d = payload[0]?.payload;
  if (!d) return null;
  return (
    <div className="bg-white border border-[#D9E2EC] rounded-lg px-3 py-2 shadow-lg text-[11px]">
      <div className="font-bold text-[#0B1F4A] mb-1">{d.label}</div>
      <div className="text-[#3D4F6F]">−20%: <strong>€{(d.lowNpv / 1e6).toFixed(2)}M</strong></div>
      <div className="text-[#3D4F6F]">+20%: <strong>€{(d.highNpv / 1e6).toFixed(2)}M</strong></div>
    </div>
  );
}

export default function SensitivityChart({ sensitivity, printMode }: { sensitivity: SensitivityItem[]; printMode?: boolean }) {
  const data = sensitivity.map(s => ({ ...s, negative: Math.min(s.impactLow, s.impactHigh), positive: Math.max(s.impactLow, s.impactHigh) }));
  return (
    <div className="bg-white rounded-xl border border-[#D9E2EC] shadow-sm p-5 mb-4">
      <div className="text-sm font-bold text-[#0B1F4A] mb-1">🔄 Gevoeligheidsanalyse</div>
      <div className="text-[11px] text-[#8899AA] mb-4">Impact van ±20% parameterwijziging op NPV</div>
      <ResponsiveContainer width="100%" height={Math.max(250, data.length * 40 + 50)}>
        <BarChart data={data} layout="vertical" margin={{ top: 5, right: 30, left: 100, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#D9E2EC" horizontal={false} />
          <XAxis type="number" tick={{ fontSize: 10, fill: '#8899AA' }} tickFormatter={v => `€${(v / 1e6).toFixed(1)}M`} />
          <YAxis type="category" dataKey="label" tick={{ fontSize: 10, fill: '#0B1F4A' }} width={95} />
          <Tooltip content={<SensTooltip />} />
          <ReferenceLine x={0} stroke="#0B1F4A" strokeWidth={1.5} />
          <Bar dataKey="negative" name="Negatief" barSize={16} radius={[3, 0, 0, 3]} isAnimationActive={!printMode}>{data.map((_, i) => <Cell key={i} fill="#F87171" />)}</Bar>
          <Bar dataKey="positive" name="Positief" barSize={16} radius={[0, 3, 3, 0]} isAnimationActive={!printMode}>{data.map((_, i) => <Cell key={i} fill="#10B981" />)}</Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
